import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { usePublisher } from "../../services/Ros/Publisher";
import '../../css/EmergencyShutdown.css'; // Import a CSS file for styling
import { ServiceCaller, useServiceCaller } from '../../services/Ros/ServiceCaller';
import { useRobotDetails } from '../../utilities/RobotDetailsContext';

const EmergencyShutdownService: React.FC = () => {
    // Get the service caller function from context
    const { callService,  } = useServiceCaller();

    // Function to handle the button click
    const handleEmergencyShutdown = async () => {
        const request: any = {data: true};  // Add any specific request fields here if needed

        try {
            const result = await callService(request);
            console.log('Service call successful:', result);
        } catch (error) {
            console.error('Service call failed:', error);
        }
    };

    return (
        <Button variant="danger" onClick={handleEmergencyShutdown}>
          Yes, Shutdown
        </Button>
    );
}


const EmergencyShutdown: React.FC = () => {
  const [isArmed, setIsArmed] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {robotDetails, } = useRobotDetails();

  const publish = usePublisher();

  const handleArm = () => {
    setIsArmed(true);
    console.log('Emergency shutdown armed.');
  };

  const handleShutdown = () => {
    if (isArmed) {
      console.log('Emergency shutdown initiated!');
      // Publish true to the emergency shutdown topic
      const message: any = { data: true };
      publish(message);
      setIsArmed(false); // Reset the armed state after shutdown
      setIsModalOpen(false); // Close the modal after shutdown
    } else {
      console.log('Please arm the shutdown button first.');
    }
  };

  const openModal = () => {
    handleArm();
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsArmed(false);
    setIsModalOpen(false);
  };

  return (
    <div className="emergency-shutdown-container">
      <Button 
        variant='warning' 
        onClick={openModal} 
        disabled={isArmed}
      >
        Arm Emergency Shutdown
      </Button>

      <Modal show={isModalOpen} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Emergency Shutdown</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to initiate the emergency shutdown?</p>
        </Modal.Body>
        <Modal.Footer>
          {robotDetails.useServices ? 
            <ServiceCaller name="/kill_switch" type="std_srvs/srv/Bool">
              <EmergencyShutdownService />
            </ServiceCaller>
            :
            <Button variant="danger" onClick={handleShutdown}>
              Yes, Shutdown
            </Button>
          }
          <Button variant="secondary" onClick={closeModal}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default EmergencyShutdown;
